// Pandectes cookie consent: footer links with href "#reopenBanner" reopen the
// banner by clicking the app's floating widget button. The button is hidden
// from first paint by x-overrides.css (--widget-float pierces the shadow
// boundary); the display:none injected below additionally removes it from the
// tab order once mounted. A hidden button still responds to .click().

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href$="#reopenBanner"]');
  if (!link) return;
  event.preventDefault();
  document.querySelector('pandectes-cmp')?.shadowRoot?.querySelector('button.widget')?.click();
});

// ponytail: 500ms poll capped at 20s — the app embed mounts async; observer not worth it
(function hidePandectesWidget(tries = 0) {
  const root = document.querySelector('pandectes-cmp')?.shadowRoot;
  if (!root) {
    if (tries < 40) setTimeout(() => hidePandectesWidget(tries + 1), 500);
    return;
  }
  root.append(
    Object.assign(document.createElement('style'), {
      textContent: '.widget{display:none !important}',
    })
  );
})();
